import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import HomeComponentMobile from './HomeComponentMobile'
import HomeComponentDesktop from './HomeComponentDesktop'
import withMediaScreenDetector from '../../hocs/withMediaScreenDetector'
import { postsOperations } from '../../state/modules/posts'
import { uiOperations } from '../../state/modules/ui'

import { ENDPOINTS } from '../../config/constants'

import './HomeComponent.css'

class HomeComponent extends Component {
  componentDidMount() {
    // endpoints.map(o=>this.props.fetchFeeds(o.url, o.name, o.homepage))
    this.props.checkSwiperActive(this.props.screenWidth);
  }
  componentWillReceiveProps(nextProps) {
    // if new feeds
    if (nextProps.fetchFeeds !== this.props.fetchFeeds) {
      console.log(nextProps.fetchFeeds);
    }
    // if screen size changes
    if (nextProps.screenWidth !== this.props.screenWidth) {
      this.props.checkSwiperActive(this.props.screenWidth);
    }
  }
  render() {
    return (
      <div className="HomeComponent">
        <div className={`ListBodyComponent ${this.props.swiperActive ? 'is-mobile' : 'is-desktop'}`}>
          { withMediaScreenDetector(this.props, this.props.swiperActive)(HomeComponentMobile, HomeComponentDesktop) }
        </div>
      </div>
    )
  }
};

function mapStateToProps(state) {
  return {
    screenWidth: state.ui.screenWidth,
    swiperActive: state.ui.swiperActive,
    checkSwiperActive: uiOperations.checkSwiperActive,
    fetchFeeds: postsOperations.fetchFeeds,
    items: state.posts.items,
    name: state.posts.name,
    fetchStatus: state.posts.fetchStatus,
    endpoints: ENDPOINTS
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    ...uiOperations,
    ...postsOperations
  }, dispatch);
}

HomeComponent.propTypes = {
  fetchFeeds: PropTypes.func,
  fetchStatus: PropTypes.shape({
    ProductHuntIsFetching: PropTypes.bool,
    ProductHuntIsRejected: PropTypes.bool,
    HackerNewsIsFetching: PropTypes.bool,
    HackerNewsIsRejected: PropTypes.bool,
    DesignerNewsIsFetching: PropTypes.bool,
    DesignerNewsIsRejected: PropTypes.bool,
    EchoJSIsFetching: PropTypes.bool,
    EchoJSIsRejected: PropTypes.bool,
  }),
  items: PropTypes.object,
  screenWidth: PropTypes.number,
  swiperActive: PropTypes.bool
}
HomeComponent.defaultProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(HomeComponent)
